(function () {
  const TEAMS_SRC = '.js-teams-source';
  const SLOT_SEL = '.js-slot';
  let dragulaInst;

  function onMatchPlaysPage() {
    return !!document.querySelector(TEAMS_SRC);
  }

  function slotInput(slot) {
    return slot.querySelector('.js-slot-input');
  }

  function setSlotTeam(slot, teamId) {
    var input = slotInput(slot);
    if (input) input.value = teamId || '';
    slot.classList.toggle('has-team', !!teamId);
    var placeholder = slot.querySelector('.match-play-slot-placeholder');
    if (placeholder) placeholder.setAttribute('style', teamId ? 'display:none!important' : '');
  }

  function teamsContainer() {
    return document.querySelector(TEAMS_SRC);
  }

  function allSlots() {
    return Array.from(document.querySelectorAll(SLOT_SEL));
  }

  function setupDragAndDrop() {
    if (dragulaInst) dragulaInst.destroy();
    const containers = [teamsContainer()].concat(allSlots()).filter(Boolean);
    dragulaInst = dragula(containers, {
      moves: function (el) {
        return el.classList.contains('team-draggable');
      },
      accepts: function (el, target) {
        if (target === teamsContainer()) return true;
        if (!target.classList.contains('js-slot')) return false;
        return !target.querySelector('.team-draggable');
      },
    }).on('drop', function (el, target, source) {
      var teamId = el.getAttribute('data-team-id');
      if (source && source.classList.contains('js-slot')) setSlotTeam(source, null);
      if (target && target.classList.contains('js-slot')) setSlotTeam(target, teamId);
      updateGroupCount();
    });
  }

  function renumberGroups() {
    document.querySelectorAll('.match-play-group').forEach(function (group, i) {
      group.dataset.groupIndex = i;
      group.querySelectorAll('.js-slot').forEach(function (slot) {
        slot.dataset.group = i;
      });
      group.querySelectorAll('.js-slot-input').forEach(function (input) {
        input.name = 'match_plays[' + i + '][]';
      });
    });
    updateGroupCount();
    setupDragAndDrop();
  }

  function updateGroupCount() {
    var badge = document.querySelector('.js-group-count');
    if (badge) badge.textContent = document.querySelectorAll('.match-play-group').length;
  }

  function buildGroupHTML(idx) {
    return [
      '<div class="match-play-group card mb-3" data-group-index="' + idx + '">',
      '  <div class="card-body bg-inverse p-3">',
      '    <div class="d-flex justify-content-end mb-2">',
      '      <a href="#" class="js-remove-group text-danger small">',
      '        <i class="mdi mdi-trash-can-outline mr-1"></i> Remove',
      '      </a>',
      '    </div>',
      [0, 1].map(function (s) {
        return [
          '<div class="slot-row d-flex align-items-center mb-2">',
          '  <div class="match-play-slot-number text-white mr-2 text-center">' + (s + 1) + '</div>',
          '  <div class="js-slot match-play-slot flex-grow-1" data-group="' + idx + '" data-slot="' + s + '">',
          '    <input type="hidden" name="match_plays[' + idx + '][]" class="js-slot-input" value="">',
          '    <div class="match-play-slot-placeholder text-white d-flex align-items-center justify-content-center w-100">',
          '      <i class="mdi mdi-tray-arrow-down mr-2"></i> Drop a team here',
          '    </div>',
          '  </div>',
          '  <button type="button" class="js-clear-slot btn btn-link btn-sm text-muted ml-1" title="Clear slot">',
          '    <i class="mdi mdi-close"></i>',
          '  </button>',
          '</div>',
        ].join('');
      }).join(''),
      '  </div>',
      '</div>',
    ].join('');
  }

  function addGroup() {
    var idx = document.querySelectorAll('.match-play-group').length;
    var container = document.querySelector('.js-groups-container');
    container.insertAdjacentHTML('beforeend', buildGroupHTML(idx));
    renumberGroups();
  }

  function removeGroup(btn) {
    if (!confirm('Remove this match play group?')) return;
    var group = btn.closest('.match-play-group');
    group.querySelectorAll('.team-draggable').forEach(function (team) {
      teamsContainer().appendChild(team);
    });
    group.remove();
    renumberGroups();
  }

  function clearSlot(btn) {
    var slot = btn.closest('.slot-row').querySelector('.js-slot');
    if (!slot) return;
    var team = slot.querySelector('.team-draggable');
    if (team) {
      teamsContainer().appendChild(team);
      setSlotTeam(slot, null);
    }
  }

  function clearAll() {
    document.querySelectorAll('.js-slot .team-draggable').forEach(function (team) {
      teamsContainer().appendChild(team);
    });
    document.querySelectorAll('.js-slot').forEach(function (slot) {
      setSlotTeam(slot, null);
    });
  }

  function filterTeams(query) {
    var q = (query || '').toLowerCase();
    document.querySelectorAll(TEAMS_SRC + ' .team-draggable').forEach(function (el) {
      var text = (el.getAttribute('data-search-text') || el.textContent).toLowerCase();
      var matches = text.includes(q);
      el.classList.toggle('d-flex', matches);
      el.classList.toggle('d-none', !matches);
    });
  }

  // Click delegation added once — guarded by onMatchPlaysPage()
  document.addEventListener('click', function (e) {
    if (!onMatchPlaysPage()) return;
    if (e.target.closest('.js-add-group')) {
      e.preventDefault();
      addGroup();
    } else if (e.target.closest('.js-remove-group')) {
      e.preventDefault();
      removeGroup(e.target.closest('.js-remove-group'));
    } else if (e.target.closest('.js-clear-slot')) {
      clearSlot(e.target.closest('.js-clear-slot'));
    } else if (e.target.closest('.js-clear-all')) {
      e.preventDefault();
      clearAll();
    }
  });

  function init() {
    if (!onMatchPlaysPage()) return;
    setupDragAndDrop();
    var searchInput = document.querySelector('.js-team-search');
    if (searchInput) {
      searchInput.value = '';
      searchInput.addEventListener('keyup', function () { filterTeams(this.value); });
      searchInput.addEventListener('input', function () { filterTeams(this.value); });
    }
  }

  document.addEventListener('turbolinks:load', init);
  window.MatchPlays = { setupDragAndDrop: setupDragAndDrop };
})();
